import { Component } from '@angular/core';

@Component({
  templateUrl: './not_found.component.html',
  styles: ['./not_found.component.scss']
})
export class NotFoundComponent {

  constructor(
  ) {
  }

}
